<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="五色评估"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <div class="assessmentdiv">
        <div class="assessmentLabel">孕产妇妊娠风险评估：</div>
        <template v-if="checkRiskList.length>0">
          <div class="assessmentLevel margin15" v-if="maxCheckLevel" :style="{'color':maxCheckLevel.color}">{{maxCheckLevel.name}}</div>
          <div class="assessmentLevel" v-if="isLevel5" style="color:#7E61F4;">孕妇患有传染性疾病</div>
        </template>
        <div v-else class="assessmentLevel margin15" :style="{'color':riskLevelList[0].color}">{{riskLevelList[0].name}}</div>
      </div>
      <div class="riskView" v-if="data.currentGeneration == 1">
        <template v-if="checkRiskList.length>0">
          <div class="riskTypeItem" v-for="item in riskTree" :key="item.tbTypeName">
            <div class="riskTypeView">{{item.tbTypeName}}</div>
            <div class="riskItem" v-for="item2 in item.list" :key="item2.tbName">
              <div class="colorItem" :style="{'background':getRiskColor(item2.tbLevel)}">{{getRiskColorName(item2.tbLevel)}}</div>
              <div class="riskText">{{item2.tbName}}</div>
            </div>
          </div>
        </template>
        <div class="riskTypeItem" v-else>
          <div class="riskTypeView">基本情况</div>
          <div class="riskItem">
            <div class="colorItem" :style="{'background':getRiskColor(1)}">{{getRiskColorName(1)}}</div>
            <div class="riskText">孕妇基本情况良好，未发现妊娠合并症、并发症</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleComponents from '@/components/mother/title'
export default {
  name: 'riskInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    riskTree: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: false,
      riskLevelList: [{
        id: 1,
        name: '低风险',
        color: '#6DD400',
        colorName: '绿色'
      },
      {
        id: 2,
        name: '一般风险',
        color: '#F7B500',
        colorName: '黄色'
      },
      {
        id: 3,
        name: '较高风险',
        color: '#FA6400',
        colorName: '橙色'
      },
      {
        id: 4,
        name: '高风险',
        color: '#E02020',
        colorName: '红色'
      },
      {
        id: 5,
        name: '孕妇患有传染性疾病',
        color: '#7E61F4',
        colorName: '紫色'
      }],
    }
  },
  created () {

  },
  computed: {
    isLevel5 () {
      return this.checkRiskLevel.includes(5)
    },
    maxCheckLevel () {
      if (this.checkRiskLevel.includes(4)) {
        return this.riskLevelList[3]
      } else if (this.checkRiskLevel.includes(3)) {
        return this.riskLevelList[2]
      } else if (this.checkRiskLevel.includes(2)) {
        return this.riskLevelList[1]
      } else if (this.checkRiskLevel.includes(1)) {
        return this.riskLevelList[0]
      } else {
        return null
      }
    },
    checkRiskLevel () {
      const set = new Set()
      this.checkRiskList.forEach(i => {
        set.add(i.tbLevel)
      })
      return Array.from(set)
    },
    checkRiskList () {
      const list = []
      this.riskTree.forEach(j => {
        j.list.forEach(i => {
          list.push(i)
        })
      })
      return list
    },
  },
  methods: {
    getRiskColor (level) {
      return this.riskLevelList.find(i => i.id === level).color
    },
    getRiskColorName (level) {
      return this.riskLevelList.find(i => i.id === level).colorName
    }
  },
  mounted () {

  },
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);

  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    .assessmentdiv {
      display: flex;
      .margin15 {
        margin: 0 15px;
      }
    }
    .riskView {
      margin: 0 32px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .riskTypeItem {
        width: 100%;
        display: flex;
        flex-direction: column;
        .riskTypeView {
          margin: 10px 0;
          box-sizing: border-box;
          padding-left: 14px;
          width: 100%;
          border-left: 2px solid #69c2ff;
          min-height: 30px;
          font-weight: 700;
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          text-align: left;
          display: flex;
          align-items: center;
        }
        .riskItem {
          margin: 5px 0;
          display: flex;
          align-items: center;
          .colorItem {
            display: inline-block;
            width: 28px;
            height: 15px;
            border-radius: 4px;
            font-weight: 400;
            font-size: 10px;
            line-height: 15px;
            text-align: center;
            margin-right: 7px;
            color: #ffffff;
          }
          .riskText {
            display: inline-block;
            background: rgba(0, 0, 0, 0.08);
            border-radius: 6px;
            padding: 5px 15px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            &.check {
              background: #d1ecff;
            }
          }
        }
      }
    }
  }
}
</style>